import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import { ar } from "./i18n/ar";
import { logError } from "./lib/log";
import { registerServiceWorker } from "./pwa/serviceWorker";
import { initInstall } from "./lib/install";
import { ErrorBoundary } from "./app/ErrorBoundary";

window.addEventListener("error", (e) => logError("runtime_error", e.error ?? e.message));
window.addEventListener("unhandledrejection", (e) => logError("unhandled_rejection", e.reason));
registerServiceWorker();
initInstall();

const root = createRoot(document.getElementById("root")!);

// Config errors throw at module load; show them instead of a blank screen.
import("./app/App")
  .then(({ default: App }) => {
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>,
    );
  })
  .catch((e: unknown) => {
    logError("app_load_failed", e);
    root.render(<p className="p-6 text-center text-red-700">{ar.shell.config_error}</p>);
  });
